export interface Product {
  id: number;
  categorySlug: string;
  name: string;
  price: number;
  originalPrice?: number;
  badge?: string;
  image: string;
  description: string;
}

export const products: Product[] = [
  {
    id: 101,
    categorySlug: 'masalar',
    name: 'Naturel Yuvarlak Aktivite Masası',
    price: 0,
    badge: 'Trend',
    image: 'https://public.readdy.ai/ai/img_res/d57bab7995de945d8e0cf08ad019b8c1.jpg',
    description: 'Doğal huş ağacından üretilmiş, yuvarlak köşeli güvenli aktivite masası',
  },
  {
    id: 102,
    categorySlug: 'masalar',
    name: 'Pastel Pembe Trapez Masa',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=trapezoidal%20children%20table%20soft%20pastel%20pink%20MDF%20panel%20natural%20birch%20wood%20legs%20kindergarten%20classroom%20Montessori%20furniture%20white%20background%20product%20photography%20child-safe%20rounded%20corners%20colorful%20playroom%20table%20elegant&width=600&height=600&seq=prod-masa-002&orientation=squarish',
    description: 'Trapez formlu, sınıf düzenlemesi için ideal birleştirilebilir masa',
  },
  {
    id: 103,
    categorySlug: 'masalar',
    name: 'Ahşap Dikdörtgen Grup Masası',
    price: 0,
    badge: 'İndirimli',
    image: 'https://readdy.ai/api/search-image?query=rectangular%20group%20activity%20table%20natural%20solid%20birch%20wood%20large%20surface%20kindergarten%20classroom%20four%20to%20six%20children%20seating%20Montessori%20furniture%20white%20background%20product%20photography%20smooth%20rounded%20edges%20child-safe%20sturdy%20construction%20warm%20wood%20grain&width=600&height=600&seq=prod-masa-003&orientation=squarish',
    description: '4-6 çocuk kapasiteli, doğal ahşap grup çalışma masası',
  },
  {
    id: 104,
    categorySlug: 'masalar',
    name: 'Mint Yeşil Kare Masa',
    price: 0,
    badge: 'Popüler',
    image: 'https://readdy.ai/api/search-image?query=square%20children%20table%20mint%20green%20pastel%20MDF%20top%20natural%20wood%20legs%20kindergarten%20preschool%20Montessori%20furniture%20white%20background%20product%20photography%20child-safe%20rounded%20corners%20colorful%20playroom%20Scandinavian%20style%20elegant%20simple&width=600&height=600&seq=prod-masa-004&orientation=squarish',
    description: 'Mint yeşili kaplamalı, kare formlu şirin çalışma masası',
  },
  {
    id: 105,
    categorySlug: 'masalar',
    name: 'Ayarlanabilir Yükseklikli Masa',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=height%20adjustable%20children%20school%20table%20birch%20wood%20legs%20adjustable%20mechanism%20kindergarten%20Montessori%20ergonomic%20furniture%20white%20background%20product%20photography%20child-safe%20smooth%20surface%20clean%20minimal%20Scandinavian%20design%20premium%20quality&width=600&height=600&seq=prod-masa-005&orientation=squarish',
    description: 'Büyüyen çocuğa uyum sağlıyan, yükseklik ayarlı ergonomik masa',
  },
  {
    id: 106,
    categorySlug: 'masalar',
    name: 'Altıgen Honeycomb Masa',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=hexagonal%20honeycomb%20shaped%20children%20play%20table%20natural%20birch%20wood%20kindergarten%20preschool%20cluster%20arrangement%20Montessori%20furniture%20white%20background%20product%20photography%20child-safe%20rounded%20corners%20modern%20creative%20design%20warm%20wood%20grain%20texture%20premium%20quality&width=600&height=600&seq=prod-masa-006&orientation=squarish',
    description: 'Altıgen formlu, cluster düzeni için tasarlanmış yaratıcı masa',
  },
  {
    id: 107,
    categorySlug: 'masalar',
    name: 'Sarı Güneş Boyalı Masa',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=cheerful%20yellow%20painted%20children%20table%20round%20MDF%20top%20bright%20sunny%20yellow%20color%20natural%20wood%20legs%20kindergarten%20playroom%20Montessori%20furniture%20white%20background%20product%20photography%20child-safe%20rounded%20edges%20colorful%20joyful%20Scandinavian%20style&width=600&height=600&seq=prod-masa-007&orientation=squarish',
    description: 'Neşeli sarı renkli, yuvarlak masası ile canlı sınıf atmosferi',
  },
  {
    id: 108,
    categorySlug: 'masalar',
    name: 'Doğal Ahşap Atölye Masası',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=solid%20birch%20wood%20workshop%20art%20table%20children%20large%20surface%20deep%20edge%20lipped%20tray%20kindergarten%20art%20craft%20studio%20Montessori%20furniture%20white%20background%20product%20photography%20sturdy%20heavy%20duty%20child-safe%20premium%20quality%20warm%20wood%20grain%20texture%20wide%20work%20surface&width=600&height=600&seq=prod-masa-008&orientation=squarish',
    description: 'Sanat ve atölye çalışmaları için geniş yüzeyli premium ahşap masa',
  },
  {
    id: 109,
    categorySlug: 'masalar',
    name: 'Mercan Kırmızısı Oval Masa',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=oval%20oblong%20children%20table%20coral%20red%20pastel%20painted%20MDF%20top%20natural%20birch%20wood%20legs%20kindergarten%20preschool%20Montessori%20furniture%20white%20background%20product%20photography%20child-safe%20smooth%20rounded%20edges%20colorful%20warm%20cozy%20playroom%20Scandinavian%20design&width=600&height=600&seq=prod-masa-009&orientation=squarish',
    description: 'Mercan rengi oval formlu, küçük grup çalışmaları için ideal masa',
  },
  {
    id: 110,
    categorySlug: 'masalar',
    name: 'Çift Katlı Depolama Masası',
    price: 0,
    badge: 'Akıllı Tasarım',
    image: 'https://readdy.ai/api/search-image?query=children%20table%20with%20lower%20storage%20shelf%20two%20tier%20natural%20birch%20wood%20kindergarten%20practical%20Montessori%20furniture%20white%20background%20product%20photography%20books%20toys%20storage%20tray%20underneath%20smooth%20rounded%20edges%20child-safe%20clean%20Scandinavian%20design%20elegant%20simple%20functional&width=600&height=600&seq=prod-masa-010&orientation=squarish',
    description: 'Alt rafında depolama bölmesi bulunan, çift katlı pratik çalışma masası',
  },
  {
    id: 201,
    categorySlug: 'sandalyeler',
    name: 'Naturel Ahşap Sırtlıklı Sandalye',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=natural%20solid%20birch%20wood%20children%20chair%20ergonomic%20backrest%20smooth%20rounded%20edges%20kindergarten%20Montessori%20furniture%20clean%20white%20studio%20background%20warm%20wood%20grain%20texture%20child-safe%20non-toxic%20Scandinavian%20design%20elegant%20simple%20form%20product%20photography&width=600&height=600&seq=prod-sandalye-001&orientation=squarish',
    description: 'Doğal huş ağacından, ergonomik sırtlıklı güvenli çocuk sandalyesi',
  },
  {
    id: 202,
    categorySlug: 'sandalyeler',
    name: 'Pastel Pembe Boyalı Sandalye',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=children%20chair%20pastel%20pink%20painted%20MDF%20seat%20natural%20birch%20wood%20legs%20kindergarten%20classroom%20Montessori%20furniture%20white%20background%20product%20photography%20child-safe%20rounded%20corners%20colorful%20playroom%20elegant%20Scandinavian%20style%20smooth%20finish&width=600&height=600&seq=prod-sandalye-002&orientation=squarish',
    description: 'Pastel pembe boyalı, şirin tasarımlı çocuk sandalyesi',
  },
  {
    id: 203,
    categorySlug: 'sandalyeler',
    name: 'Mint Yeşili Istiflenir Sandalye',
    price: 0,
    badge: 'Popüler',
    image: 'https://readdy.ai/api/search-image?query=stackable%20children%20chair%20mint%20green%20seat%20back%20solid%20birch%20wood%20legs%20kindergarten%20space-saving%20stack%20of%20chairs%20Montessori%20furniture%20white%20background%20product%20photography%20smooth%20rounded%20edges%20child-safe%20Scandinavian%20design%20clean%20minimal%20practical&width=600&height=600&seq=prod-sandalye-003&orientation=squarish',
    description: 'İstifleme özellikli, mint yeşili renkli pratik sınıf sandalyesi',
  },
  {
    id: 204,
    categorySlug: 'sandalyeler',
    name: 'Yükseklik Ayarlı Ergonomik Sandalye',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=height%20adjustable%20children%20ergonomic%20chair%20natural%20birch%20wood%20seat%20adjustable%20leg%20mechanism%20kindergarten%20Montessori%20school%20furniture%20white%20background%20product%20photography%20smooth%20rounded%20edges%20child-safe%20premium%20quality%20Scandinavian%20design&width=600&height=600&seq=prod-sandalye-004&orientation=squarish',
    description: 'Büyüyen çocuğa uyum sağlıyan, yükseklik ayarlı ergonomik sandalye',
  },
  {
    id: 205,
    categorySlug: 'sandalyeler',
    name: 'Sarı Güneş Boyalı Sandalye',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=cheerful%20yellow%20painted%20children%20chair%20bright%20sunny%20yellow%20seat%20natural%20birch%20wood%20legs%20kindergarten%20playroom%20Montessori%20furniture%20white%20background%20product%20photography%20child-safe%20rounded%20edges%20colorful%20joyful%20Scandinavian%20style&width=600&height=600&seq=prod-sandalye-005&orientation=squarish',
    description: 'Neşeli sarı renkli, çocuk oyun köşesi için ideal sandalye',
  },
  {
    id: 206,
    categorySlug: 'sandalyeler',
    name: 'Mercan Kırmızısı Minderli Sandalye',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=children%20chair%20coral%20red%20upholstered%20padded%20cushion%20seat%20natural%20birch%20wood%20frame%20kindergarten%20cozy%20comfortable%20Montessori%20furniture%20white%20background%20product%20photography%20smooth%20rounded%20edges%20child-safe%20premium%20fabric%20warm%20colorful&width=600&height=600&seq=prod-sandalye-006&orientation=squarish',
    description: 'Mercan rengi minderli, yumuşak oturma yüzeyli konforlu sandalye',
  },
  {
    id: 207,
    categorySlug: 'sandalyeler',
    name: 'Naturel Kare Gövdeli Sandalye',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=children%20chair%20square%20frame%20solid%20natural%20birch%20wood%20simple%20geometric%20kindergarten%20Montessori%20furniture%20white%20background%20product%20photography%20smooth%20rounded%20edges%20child-safe%20Scandinavian%20minimal%20design%20elegant%20warm%20wood%20grain%20texture&width=600&height=600&seq=prod-sandalye-007&orientation=squarish',
    description: 'Kare geometrik gövdeli, sade ve şık doğal ahşap sandalye',
  },
  {
    id: 208,
    categorySlug: 'sandalyeler',
    name: 'Lavanta Mor Boyalı Sandalye',
    price: 0,
    badge: 'İndirimli',
    image: 'https://readdy.ai/api/search-image?query=children%20chair%20soft%20lavender%20purple%20pastel%20painted%20seat%20back%20natural%20birch%20wood%20legs%20kindergarten%20classroom%20Montessori%20furniture%20white%20background%20product%20photography%20child-safe%20rounded%20corners%20colorful%20playroom%20Scandinavian%20style%20elegant%20smooth%20finish%20gentle%20tone&width=600&height=600&seq=prod-sandalye-008&orientation=squarish',
    description: 'Soft lavanta mor renkli, pastel tonlarda şirin çocuk sandalyesi',
  },
  {
    id: 209,
    categorySlug: 'sandalyeler',
    name: 'Renkli Eyer Sandalye',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=children%20saddle%20seat%20ergonomic%20chair%20colorful%20pastel%20coral%20seat%20natural%20birch%20wood%20legs%20kindergarten%20active%20sitting%20Montessori%20posture%20furniture%20white%20background%20product%20photography%20child-safe%20modern%20creative%20design%20premium%20quality%20active%20learning&width=600&height=600&seq=prod-sandalye-009&orientation=squarish',
    description: 'Eyer formlu oturma yüzeyiyle duruşu destekleyen aktif sandalye',
  },
  {
    id: 210,
    categorySlug: 'sandalyeler',
    name: 'Premium Kolçaklı Sandalye',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=children%20chair%20with%20armrests%20natural%20solid%20birch%20wood%20ergonomic%20backrest%20armrests%20premium%20kindergarten%20Montessori%20furniture%20white%20background%20product%20photography%20smooth%20rounded%20edges%20child-safe%20Scandinavian%20design%20warm%20wood%20grain%20texture%20premium%20quality%20upscale%20preschool%20chair&width=600&height=600&seq=prod-sandalye-010&orientation=squarish',
    description: 'Kolçaklı, tam ergonomik destekli premium çocuk sandalyesi',
  },
  {
    id: 301,
    categorySlug: 'puflu-modul-masalar',
    name: 'Mercan Puflu Yuvarlak Modül Masa',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=round%20children%20modular%20table%20with%20built-in%20upholstered%20padded%20bench%20seat%20coral%20red%20soft%20fabric%20cushion%20natural%20birch%20wood%20frame%20kindergarten%20furniture%20white%20background%20product%20photography%20child-safe%20rounded%20edges%20cozy%20learning%20corner%20Montessori&width=600&height=600&seq=prod-puflu-001&orientation=squarish',
    description: 'Entegre mercan rengi minderli, yuvarlak puflu modül masa',
  },
  {
    id: 302,
    categorySlug: 'puflu-modul-masalar',
    name: 'Mint Yeşili Köşe Puf Masası',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=corner%20L-shaped%20children%20modular%20table%20with%20integrated%20upholstered%20mint%20green%20padded%20bench%20seat%20birch%20wood%20frame%20kindergarten%20furniture%20white%20background%20product%20photography%20cozy%20seating%20corner%20Montessori%20inspired&width=600&height=600&seq=prod-puflu-002&orientation=squarish',
    description: 'Köşe düzeni için tasarlanmış, mint yeşili entegre oturmalı masa',
  },
  {
    id: 303,
    categorySlug: 'puflu-modul-masalar',
    name: 'Pastel Sarı Trapez Puf Masa',
    price: 0,
    badge: 'Popüler',
    image: 'https://readdy.ai/api/search-image?query=trapezoidal%20children%20modular%20table%20pastel%20yellow%20upholstered%20foam%20padded%20bench%20seat%20natural%20birch%20wood%20frame%20kindergarten%20furniture%20white%20background%20product%20photography%20child-safe%20rounded%20edges%20learning%20corner&width=600&height=600&seq=prod-puflu-003&orientation=squarish',
    description: 'Sarı minderli trapez puflu modül masa, sınıf düzeni için ideal',
  },
  {
    id: 304,
    categorySlug: 'puflu-modul-masalar',
    name: 'Lacivert Çift Puflu Uzun Masa',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=long%20rectangular%20children%20table%20double-sided%20integrated%20upholstered%20bench%20seats%20navy%20blue%20padded%20foam%20cushion%20birch%20wood%20frame%20kindergarten%20communal%20furniture%20white%20background%20product%20photography%20child-safe%20premium%20quality&width=600&height=600&seq=prod-puflu-004&orientation=squarish',
    description: 'Her iki yanında puf oturma alanı bulunan uzun grup masası',
  },
  {
    id: 305,
    categorySlug: 'puflu-modul-masalar',
    name: 'Pembe Yuvarlak Ada Puf Masa',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=round%20island%20children%20activity%20table%20full%20perimeter%20integrated%20upholstered%20pink%20foam%20bench%20seat%20natural%20birch%20wood%20frame%20kindergarten%20island%20furniture%20white%20background%20product%20photography%20cozy%20learning%20pod%20Montessori&width=600&height=600&seq=prod-puflu-005&orientation=squarish',
    description: 'Çepeçevre oturma yüzeyli, pembe ada puf masası',
  },
  {
    id: 306,
    categorySlug: 'puflu-modul-masalar',
    name: 'Gökkuşağı Renkli Kare Puf Masa',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=square%20children%20modular%20table%20rainbow%20multicolor%20pastel%20padded%20bench%20seats%20colorful%20foam%20cushions%20natural%20birch%20wood%20frame%20kindergarten%20playful%20furniture%20white%20background%20product%20photography%20child-safe%20premium%20quality&width=600&height=600&seq=prod-puflu-006&orientation=squarish',
    description: 'Gökkuşağı renkli mini minderleriyle kare puflu modül masa',
  },
  {
    id: 307,
    categorySlug: 'puflu-modul-masalar',
    name: 'Naturel Ahşap Puf Okuma Masası',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=natural%20birch%20wood%20children%20reading%20table%20low%20height%20integrated%20upholstered%20neutral%20beige%20foam%20bench%20seat%20comfortable%20reading%20corner%20Montessori%20furniture%20white%20background%20product%20photography%20child-safe%20Scandinavian%20minimal&width=600&height=600&seq=prod-puflu-007&orientation=squarish',
    description: 'Okuma köşesi için alçak profilli, naturel puflu okuma masası',
  },
  {
    id: 308,
    categorySlug: 'puflu-modul-masalar',
    name: 'Turuncu Akıllı Depolama Puf Masa',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=children%20modular%20table%20orange%20padded%20bench%20seat%20with%20hidden%20storage%20compartment%20under%20seat%20birch%20wood%20kindergarten%20smart%20furniture%20white%20background%20product%20photography%20premium%20quality%20practical%20design%20child-safe&width=600&height=600&seq=prod-puflu-008&orientation=squarish',
    description: 'Oturma bölümünün altında gizli depolama compartmanı bulunan puf masa',
  },
  {
    id: 309,
    categorySlug: 'puflu-modul-masalar',
    name: 'Lila Birleştirilebilir Puf Masa Seti',
    price: 0,
    badge: 'Akıllı Tasarım',
    image: 'https://readdy.ai/api/search-image?query=modular%20connectable%20children%20table%20set%20lavender%20lilac%20padded%20bench%20seat%20units%20that%20connect%20together%20birch%20wood%20kindergarten%20furniture%20white%20background%20product%20photography%20flexible%20classroom%20arrangement%20child-safe&width=600&height=600&seq=prod-puflu-009&orientation=squarish',
    description: 'Birbirine bağlanabilen parçalardan oluşan lila puflu modül masa seti',
  },
  {
    id: 310,
    categorySlug: 'puflu-modul-masalar',
    name: 'Beyaz Minimal Elips Puf Masa',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=elliptical%20oval%20children%20modular%20table%20white%20padded%20foam%20bench%20seat%20natural%20birch%20wood%20frame%20kindergarten%20Scandinavian%20minimal%20furniture%20white%20background%20product%20photography%20clean%20elegant%20child-safe%20design&width=600&height=600&seq=prod-puflu-010&orientation=squarish',
    description: 'Beyaz minderli elips formlu, Scandi esintili minimal puf masa',
  },
  {
    id: 401,
    categorySlug: 'ayakkabilik',
    name: 'Çift Katlı Naturel Ayakkabılık',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=two-tier%20natural%20birch%20wood%20children%20shoe%20rack%20kindergarten%20entrance%20cubby%20organizer%20open%20compartments%20neat%20clean%20white%20background%20product%20photography%20child-accessible%20height%20Scandinavian%20minimal%20design%20Montessori&width=600&height=600&seq=prod-ayak-001&orientation=squarish',
    description: 'Çift katlı, 12 çift kapasiteli doğal ahşap ayakkabılık',
  },
  {
    id: 402,
    categorySlug: 'ayakkabilik',
    name: 'Renkli Cubby Bireysel Ayakkabılık',
    price: 0,
    badge: 'Popüler',
    image: 'https://readdy.ai/api/search-image?query=individual%20cubby%20shoe%20storage%20unit%20colorful%20pastel%20painted%20compartments%20coral%20mint%20yellow%20each%20slot%20for%20one%20child%20natural%20birch%20wood%20frame%20kindergarten%20entrance%20furniture%20white%20background%20product%20photography%20personalized%20name%20plate%20holders&width=600&height=600&seq=prod-ayak-002&orientation=squarish',
    description: 'Bireysel renkli gözlü, isim etiketli çocuk başı ayakkabılık',
  },
  {
    id: 403,
    categorySlug: 'ayakkabilik',
    name: 'Oturmalı Ayakkabılık Bankı',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=children%20shoe%20storage%20bench%20seat%20padded%20top%20natural%20birch%20wood%20lower%20shoe%20cubby%20compartments%20kindergarten%20entrance%20entryway%20furniture%20white%20background%20product%20photography%20child-safe%20practical%20sit-and-shoe%20solution%20Montessori&width=600&height=600&seq=prod-ayak-003&orientation=squarish',
    description: 'Üstünde oturulabilen, altında ayakkabı bölmesi olan banka ayakkabılık',
  },
  {
    id: 404,
    categorySlug: 'ayakkabilik',
    name: 'Pastel Mint Duvar Ayakkabılığı',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=wall-mounted%20children%20shoe%20rack%20mint%20green%20painted%20MDF%20birch%20wood%20kindergarten%20space-saving%20vertical%20design%20clean%20white%20background%20product%20photography%20lightweight%20modern%20practical%208-pair%20capacity&width=600&height=600&seq=prod-ayak-004&orientation=squarish',
    description: 'Duvara monte, yer tasarruflu mint yeşili 8 çift ayakkabılık',
  },
  {
    id: 405,
    categorySlug: 'ayakkabilik',
    name: 'Figürlü Üçlü Ayakkabılık',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=children%20shoe%20rack%20with%20cute%20animal%20figure%20decoration%20three-tier%20birch%20wood%20natural%20finish%20kindergarten%20entrance%20charming%20whimsical%20product%20photography%20white%20background%20child-friendly%20design%20Montessori%20preschool&width=600&height=600&seq=prod-ayak-005&orientation=squarish',
    description: 'Sevimli hayvan figürlü dekoratif, 3 katlı çocuk ayakkabılığı',
  },
  {
    id: 406,
    categorySlug: 'ayakkabilik',
    name: 'Premium Kilitli Ayakkabılık',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=premium%20children%20shoe%20storage%20cabinet%20individual%20locked%20compartments%20natural%20birch%20wood%20kindergarten%20secure%20personal%20storage%20white%20background%20product%20photography%20clean%20Scandinavian%20minimal%20design%20quality%20craftsmanship&width=600&height=600&seq=prod-ayak-006&orientation=squarish',
    description: 'Kilitli bireysel bölmeli, güvenli premium dolap tipi ayakkabılık',
  },
  {
    id: 407,
    categorySlug: 'ayakkabilik',
    name: 'Taşınabilir Mini Ayakkabılık',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=portable%20compact%20small%20children%20shoe%20organizer%20rack%20natural%20birch%20wood%20handles%20easy%20carry%20kindergarten%20furniture%20white%20background%20product%20photography%20lightweight%20minimal%20two-pair%20capacity%20small%20space%20solution&width=600&height=600&seq=prod-ayak-007&orientation=squarish',
    description: 'Taşıma kolları olan küçük ve pratik mini çocuk ayakkabılığı',
  },
  {
    id: 408,
    categorySlug: 'ayakkabilik',
    name: 'Mercan Boyalı Geniş Ayakkabılık',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=wide%20children%20shoe%20rack%20coral%20painted%20MDF%20shelves%20natural%20birch%20wood%20frame%20kindergarten%2020-pair%20large%20capacity%20entrance%20furniture%20white%20background%20product%20photography%20practical%20organized%20clean%20design&width=600&height=600&seq=prod-ayak-008&orientation=squarish',
    description: 'Mercan rengi geniş raflı, 20 çift kapasiteli büyük ayakkabılık',
  },
  {
    id: 409,
    categorySlug: 'ayakkabilik',
    name: 'İsimlikli Akıllı Ayakkabılık',
    price: 0,
    badge: 'Akıllı Tasarım',
    image: 'https://readdy.ai/api/search-image?query=children%20shoe%20rack%20with%20individual%20name%20plate%20slots%20photo%20holder%20compartments%20natural%20birch%20wood%20kindergarten%20personalized%20cubby%20entrance%20furniture%20white%20background%20product%20photography%20organized%20classroom%20entry%20Montessori&width=600&height=600&seq=prod-ayak-009&orientation=squarish',
    description: 'Fotoğraf ve isim etiketi bölmeli kişiselleştirilebilir akıllı ayakkabılık',
  },
  {
    id: 410,
    categorySlug: 'ayakkabilik',
    name: 'Altı Çekmeceli Ayakkabılık',
    price: 0,
    badge: 'İndirimli',
    image: 'https://readdy.ai/api/search-image?query=children%20shoe%20storage%20unit%20six%20individual%20drawer%20pull-out%20compartments%20natural%20birch%20wood%20colorful%20pastel%20drawer%20fronts%20kindergarten%20furniture%20white%20background%20product%20photography%20neat%20organized%20practical%20design%20child-safe&width=600&height=600&seq=prod-ayak-010&orientation=squarish',
    description: 'Altı adet çekmeceli, bireysel saklama bölmeli ayakkabılık ünitesi',
  },
  {
    id: 501,
    categorySlug: 'dolaplar',
    name: 'Çift Kapılı Bireysel Gardırop',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=double%20door%20children%20personal%20wardrobe%20locker%20natural%20birch%20wood%20pastel%20coral%20handle%20kindergarten%20coat%20hook%20inside%20shelf%20storage%20white%20background%20product%20photography%20clean%20Scandinavian%20minimal%20child-safe%20quality&width=600&height=600&seq=prod-dolap-001&orientation=squarish',
    description: 'İçinde askı ve raf bulunan çift kapılı bireysel gardırop dolabı',
  },
  {
    id: 502,
    categorySlug: 'dolaplar',
    name: 'Açık Raf Oyuncak Dolabı',
    price: 0,
    badge: 'Popüler',
    image: 'https://readdy.ai/api/search-image?query=open%20shelf%20children%20toy%20storage%20cabinet%20natural%20birch%20wood%20multiple%20levels%20kindergarten%20Montessori%20accessible%20toy%20storage%20furniture%20white%20background%20product%20photography%20clean%20minimal%20Scandinavian%20organized%20cubbies&width=600&height=600&seq=prod-dolap-002&orientation=squarish',
    description: 'Açık raflı, kolay erişimli Montessori oyuncak depolama dolabı',
  },
  {
    id: 503,
    categorySlug: 'dolaplar',
    name: 'Renkli Çekmeceli Alçak Dolap',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=low%20children%20storage%20cabinet%20colorful%20pastel%20drawers%20mint%20coral%20yellow%20birch%20wood%20frame%20kindergarten%20accessible%20child-height%20furniture%20white%20background%20product%20photography%20Montessori%20bedroom%20classroom%20organizer&width=600&height=600&seq=prod-dolap-003&orientation=squarish',
    description: 'Çocuk hizasında, renkli çekmeceli alçak depolama dolabı',
  },
  {
    id: 504,
    categorySlug: 'dolaplar',
    name: 'Mini Boyalı Kıyafet Dolabı',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=small%20children%20clothes%20wardrobe%20cabinet%20painted%20white%20mint%20green%20natural%20birch%20wood%20legs%20coat%20hooks%20inside%20hat%20shelf%20kindergarten%20preschool%20furniture%20white%20background%20product%20photography%20child-safe%20cute%20practical%20design&width=600&height=600&seq=prod-dolap-004&orientation=squarish',
    description: 'Askı barı ve şapka rafıyla donanımlı küçük kıyafet dolabı',
  },
  {
    id: 505,
    categorySlug: 'dolaplar',
    name: 'Geniş Sınıf Malzeme Dolabı',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=wide%20tall%20children%20classroom%20material%20storage%20cabinet%20natural%20birch%20wood%20multiple%20shelves%20doors%20kindergarten%20teacher%20supply%20storage%20furniture%20white%20background%20product%20photography%20practical%20organized%20clean%20Scandinavian%20design&width=600&height=600&seq=prod-dolap-005&orientation=squarish',
    description: 'Geniş ve yüksek, sınıf malzemeleri için çok raflı dolap',
  },
  {
    id: 506,
    categorySlug: 'dolaplar',
    name: 'Cam Kapaklı Sergi Dolabı',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=children%20display%20cabinet%20glass%20doors%20natural%20birch%20wood%20frame%20kindergarten%20art%20projects%20trophies%20display%20showcase%20white%20background%20product%20photography%20clean%20elegant%20Scandinavian%20design%20safe%20tempered%20glass&width=600&height=600&seq=prod-dolap-006&orientation=squarish',
    description: 'Cam kapaklı, çocuk eserlerinin sergilendiği şeffaf vitrin dolabı',
  },
  {
    id: 507,
    categorySlug: 'dolaplar',
    name: 'Tekerlekli Seyyar Dolap',
    price: 0,
    badge: 'Akıllı Tasarım',
    image: 'https://readdy.ai/api/search-image?query=mobile%20rolling%20children%20storage%20cabinet%20wheels%20natural%20birch%20wood%20kindergarten%20flexible%20classroom%20arrangement%20furniture%20white%20background%20product%20photography%20practical%20lockable%20casters%20child-safe%20Montessori&width=600&height=600&seq=prod-dolap-007&orientation=squarish',
    description: 'Tekerlekli, sınıf içinde kolayca hareket ettirilebilen seyyar dolap',
  },
  {
    id: 508,
    categorySlug: 'dolaplar',
    name: 'Pastel Makyaj / Sanat Dolabı',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=children%20art%20supply%20craft%20cabinet%20pastel%20painted%20compartments%20brushes%20paint%20organizer%20birch%20wood%20kindergarten%20art%20room%20furniture%20white%20background%20product%20photography%20clean%20practical%20accessible%20small%20slots%20pots%20holders&width=600&height=600&seq=prod-dolap-008&orientation=squarish',
    description: 'Sanat malzemeleri için bölmelendirilmiş pastel renkli atölye dolabı',
  },
  {
    id: 509,
    categorySlug: 'dolaplar',
    name: 'Altlıklı Çift Katlı Dolap',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=two%20section%20stacked%20children%20storage%20cabinet%20upper%20lower%20compartments%20natural%20birch%20wood%20coral%20handle%20kindergarten%20Montessori%20furniture%20white%20background%20product%20photography%20organized%20simple%20clean%20design%20premium%20quality&width=600&height=600&seq=prod-dolap-009&orientation=squarish',
    description: 'Üst ve alt bölmeli, iki katlı çok amaçlı depolama dolabı',
  },
  {
    id: 510,
    categorySlug: 'dolaplar',
    name: 'L Köşe Modüler Depolama Ünitesi',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=L-shaped%20corner%20children%20modular%20storage%20unit%20natural%20birch%20wood%20open%20shelves%20closed%20compartments%20kindergarten%20classroom%20corner%20furniture%20white%20background%20product%20photography%20Scandinavian%20design%20Montessori%20organized&width=600&height=600&seq=prod-dolap-010&orientation=squarish',
    description: 'L formlu köşe tasarımı, modüler çok amaçlı depolama ünitesi',
  },
  {
    id: 601,
    categorySlug: 'kitaplik',
    name: 'Alçak Montessori Kitap Standı',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=low%20children%20Montessori%20book%20display%20stand%20natural%20birch%20wood%20front-facing%20display%20shelf%20kindergarten%20reading%20corner%20accessible%20height%20easy%20reach%20white%20background%20product%20photography%20warm%20wood%20grain%20clean%20minimal%20Scandinavian&width=600&height=600&seq=prod-kitap-001&orientation=squarish',
    description: 'Kapakları öne bakan, alçak profilli Montessori kitap standı',
  },
  {
    id: 602,
    categorySlug: 'kitaplik',
    name: 'Renkli Tematik Dört Raflı Kitaplık',
    price: 0,
    badge: 'Popüler',
    image: 'https://readdy.ai/api/search-image?query=colorful%20four-shelf%20children%20bookcase%20pastel%20painted%20shelves%20coral%20mint%20yellow%20natural%20birch%20wood%20frame%20kindergarten%20classroom%20library%20furniture%20white%20background%20product%20photography%20Montessori%20design%20organized%20children%20books&width=600&height=600&seq=prod-kitap-002&orientation=squarish',
    description: 'Renkli raflı, 4 katlı geniş kapasiteli çocuk kitaplığı',
  },
  {
    id: 603,
    categorySlug: 'kitaplik',
    name: 'Döner Kitap Karüseli',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=rotating%20spinning%20children%20book%20carousel%20display%20stand%20natural%20birch%20wood%20multiple%20tiers%20360%20degree%20access%20kindergarten%20library%20furniture%20white%20background%20product%20photography%20Montessori%20creative%20design%20engaging%20books&width=600&height=600&seq=prod-kitap-003&orientation=squarish',
    description: '360° dönen, tüm taraflardan kitap erişimli karüsel kitaplık',
  },
  {
    id: 604,
    categorySlug: 'kitaplik',
    name: 'Duvar Montajlı Kitap Cebi',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=wall-mounted%20children%20book%20pocket%20display%20shelf%20natural%20birch%20wood%20fabric%20canvas%20pockets%20front-facing%20books%20kindergarten%20reading%20wall%20decoration%20white%20background%20product%20photography%20space-saving%20minimal&width=600&height=600&seq=prod-kitap-004&orientation=squarish',
    description: 'Duvara monte, kumaş cepli kitap sergileme ve saklama ünitesi',
  },
  {
    id: 605,
    categorySlug: 'kitaplik',
    name: 'Pastel Sarı Köşe Kitaplık',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=corner%20children%20bookshelf%20pastel%20yellow%20painted%20MDF%20natural%20birch%20wood%20frame%20kindergarten%20reading%20nook%20corner%20furniture%20white%20background%20product%20photography%20Montessori%20accessible%20cozy%20book%20storage&width=600&height=600&seq=prod-kitap-005&orientation=squarish',
    description: 'Köşe tasarımlı, sarı boyalı şirin okuma köşesi kitaplığı',
  },
  {
    id: 606,
    categorySlug: 'kitaplik',
    name: 'Premium Ahşap Büyük Kütüphane',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=large%20premium%20solid%20birch%20wood%20children%20library%20bookcase%20tall%20multiple%20shelves%20kindergarten%20classroom%20wide%20capacity%20book%20storage%20Scandinavian%20minimal%20furniture%20white%20background%20product%20photography%20premium%20quality%20warm%20wood&width=600&height=600&seq=prod-kitap-006&orientation=squarish',
    description: 'Geniş kapasiteli, premium doğal ahşap çok katlı çocuk kütüphanesi',
  },
  {
    id: 607,
    categorySlug: 'kitaplik',
    name: 'Puf Oturmalı Kitaplık Köşesi',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=children%20bookshelf%20with%20integrated%20padded%20reading%20nook%20seat%20natural%20birch%20wood%20mint%20green%20cushion%20kindergarten%20cozy%20corner%20reading%20area%20book%20storage%20furniture%20white%20background%20product%20photography%20Montessori&width=600&height=600&seq=prod-kitap-007&orientation=squarish',
    description: 'Entegre oturma yüzeyli, okuma nişli kombine kitaplık köşesi',
  },
  {
    id: 608,
    categorySlug: 'kitaplik',
    name: 'Tekerlekli Gezgin Kitaplık',
    price: 0,
    badge: 'Akıllı Tasarım',
    image: 'https://readdy.ai/api/search-image?query=mobile%20rolling%20children%20bookshelf%20cart%20natural%20birch%20wood%20wheels%20lockable%20kindergarten%20flexible%20classroom%20library%20furniture%20white%20background%20product%20photography%20practical%20organized%20minimal%20design%20Montessori&width=600&height=600&seq=prod-kitap-008&orientation=squarish',
    description: 'Tekerlekli, sınıfta kolayca taşınabilen gezgin kitaplık arabası',
  },
  {
    id: 609,
    categorySlug: 'kitaplik',
    name: 'Figürlü Ağaç Kitaplık',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=tree%20shaped%20children%20bookshelf%20natural%20birch%20wood%20whimsical%20organic%20branch%20shape%20shelves%20kindergarten%20playful%20reading%20corner%20furniture%20white%20background%20product%20photography%20creative%20design%20charming%20cute%20kids%20room%20decor&width=600&height=600&seq=prod-kitap-009&orientation=squarish',
    description: 'Ağaç dalı formunda, masalsı tasarımlı figürlü kitaplık',
  },
  {
    id: 610,
    categorySlug: 'kitaplik',
    name: 'İkili Yüz Yüze Okuma Kitaplığı',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=double-sided%20back-to-back%20children%20bookshelf%20natural%20birch%20wood%20kindergarten%20library%20room%20divider%20front-facing%20display%20both%20sides%20furniture%20white%20background%20product%20photography%20Montessori%20classroom%20partition%20organizer&width=600&height=600&seq=prod-kitap-010&orientation=squarish',
    description: 'İki taraflı, oda bölücü işlevli karşılıklı kitaplık ünitesi',
  },
  {
    id: 701,
    categorySlug: 'duvar-borduru',
    name: 'Pastel Köpek Figürlü Bordür',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=soft%20padded%20wall%20border%20panel%20kindergarten%20cute%20cartoon%20puppy%20dog%20faces%20pastel%20mint%20yellow%20fabric%20upholstered%20foam%20child-safe%20rounded%20edges%20playroom%20wall%20trim%20product%20photography%20white%20background%20preschool%20decor%20cheerful&width=600&height=600&seq=prod-bordr-001&orientation=squarish',
    description: 'Sevimli köpek yavrusu figürlü pastel renkli duvar bordür paneli',
  },
  {
    id: 702,
    categorySlug: 'duvar-borduru',
    name: 'Gökkuşağı Bulutlu Bordür Seti',
    price: 0,
    badge: 'Popüler',
    image: 'https://readdy.ai/api/search-image?query=colorful%20padded%20wall%20border%20panel%20set%20kindergarten%20rainbow%20cloud%20sunshine%20soft%20fabric%20upholstered%20panels%20pastel%20pink%20blue%20yellow%20child-safe%20rounded%20edges%20playroom%20continuous%20border%20white%20background%20product%20photography%20preschool&width=600&height=600&seq=prod-bordr-002&orientation=squarish',
    description: 'Gökkuşağı ve bulut motifli, renkli pastel duvar bordür seti',
  },
  {
    id: 703,
    categorySlug: 'duvar-borduru',
    name: 'Orman Hayvanları Bordür Paneli',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=forest%20animals%20padded%20wall%20border%20panel%20kindergarten%20cute%20fox%20bear%20rabbit%20owl%20soft%20upholstered%20fabric%20pastel%20green%20brown%20sage%20tones%20child-safe%20rounded%20edges%20classroom%20wall%20trim%20white%20background%20product%20photography&width=600&height=600&seq=prod-bordr-003&orientation=squarish',
    description: 'Tilki, ayı, tavşan figürlü orman temalı bordür paneli',
  },
  {
    id: 704,
    categorySlug: 'duvar-borduru',
    name: 'Deniz Canlıları Bordür Seti',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=ocean%20sea%20creatures%20padded%20wall%20border%20panel%20kindergarten%20cute%20fish%20whale%20octopus%20soft%20upholstered%20pastel%20blue%20coral%20tones%20fabric%20child-safe%20rounded%20edges%20playroom%20wall%20decor%20white%20background%20product%20photography&width=600&height=600&seq=prod-bordr-004&orientation=squarish',
    description: 'Balık, balina, ahtapot figürlü deniz temalı bordür seti',
  },
  {
    id: 705,
    categorySlug: 'duvar-borduru',
    name: 'Çiçek Bahçesi Bordür Paneli',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=flower%20garden%20padded%20wall%20border%20panel%20kindergarten%20colorful%20soft%20fabric%20flowers%20daisies%20sunflowers%20tulips%20pastel%20pink%20yellow%20green%20upholstered%20child-safe%20rounded%20edges%20playroom%20classroom%20white%20background%20product%20photography&width=600&height=600&seq=prod-bordr-005&orientation=squarish',
    description: 'Çiçek bahçesi motifli, renkli yumuşak duvar bordür paneli',
  },
  {
    id: 706,
    categorySlug: 'duvar-borduru',
    name: 'Uzay Temalı Bordür Seti',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=space%20theme%20padded%20wall%20border%20panel%20kindergarten%20cute%20rocket%20planets%20stars%20astronaut%20soft%20fabric%20upholstered%20pastel%20navy%20mint%20tones%20child-safe%20rounded%20edges%20playroom%20wall%20decor%20white%20background%20product%20photography%20creative&width=600&height=600&seq=prod-bordr-006&orientation=squarish',
    description: 'Roket, gezegen ve astronot figürlü uzay temalı bordür seti',
  },
  {
    id: 707,
    categorySlug: 'duvar-borduru',
    name: 'Dinozor Dünyası Bordür Paneli',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=dinosaur%20world%20padded%20wall%20border%20panel%20kindergarten%20cute%20friendly%20cartoon%20dinosaurs%20t-rex%20triceratops%20soft%20fabric%20upholstered%20pastel%20green%20coral%20yellow%20child-safe%20rounded%20edges%20playroom%20white%20background%20product%20photography&width=600&height=600&seq=prod-bordr-007&orientation=squarish',
    description: 'Sevimli dinozor figürlü, çocukların favorisi bordür paneli',
  },
  {
    id: 708,
    categorySlug: 'duvar-borduru',
    name: 'Safari Hayvanları Bordür Seti',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=safari%20animals%20padded%20wall%20border%20panel%20kindergarten%20cute%20giraffe%20lion%20elephant%20zebra%20soft%20upholstered%20fabric%20pastel%20beige%20coral%20orange%20tones%20child-safe%20rounded%20edges%20playroom%20continuous%20border%20white%20background%20product%20photography&width=600&height=600&seq=prod-bordr-008&orientation=squarish',
    description: 'Zürafa, aslan, fil figürlü safari temalı duvar bordür seti',
  },
  {
    id: 709,
    categorySlug: 'duvar-borduru',
    name: 'Peri Masalı Bordür Paneli',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=fairy%20tale%20padded%20wall%20border%20panel%20kindergarten%20cute%20castle%20princess%20unicorn%20fairy%20soft%20fabric%20upholstered%20pastel%20pink%20lavender%20gold%20tones%20child-safe%20rounded%20edges%20playroom%20white%20background%20product%20photography%20premium%20quality&width=600&height=600&seq=prod-bordr-009&orientation=squarish',
    description: 'Unicorn, prenses ve kale motifli peri masalı temalı bordür',
  },
  {
    id: 710,
    categorySlug: 'duvar-borduru',
    name: 'Sade Geometrik Bordür Seti',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=geometric%20pattern%20padded%20wall%20border%20panel%20kindergarten%20modern%20simple%20shapes%20triangles%20circles%20hexagons%20soft%20upholstered%20fabric%20pastel%20mint%20coral%20yellow%20child-safe%20rounded%20edges%20playroom%20minimal%20Scandinavian%20white%20background%20product%20photography&width=600&height=600&seq=prod-bordr-010&orientation=squarish',
    description: 'Modern geometrik desenli, sade ve şık Scandi tarzı bordür seti',
  },
  {
    id: 801,
    categorySlug: 'karalama-tahtalari',
    name: 'Doğal Ahşap Çerçeveli Kara Tahta',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=natural%20birch%20wood%20framed%20chalkboard%20children%20classroom%20kindergarten%20wall%20mounted%20chalk%20writing%20drawing%20board%20white%20background%20product%20photography%20clean%20minimal%20Scandinavian%20design%20child-safe%20quality&width=600&height=600&seq=prod-kara-001&orientation=squarish',
    description: 'Doğal ahşap çerçeveli, duvara monte klasik kara tahta',
  },
  {
    id: 802,
    categorySlug: 'karalama-tahtalari',
    name: 'İki Yüzlü Manyetik Tahta',
    price: 0,
    badge: 'Popüler',
    image: 'https://readdy.ai/api/search-image?query=double-sided%20magnetic%20whiteboard%20chalkboard%20children%20standing%20easel%20birch%20wood%20frame%20kindergarten%20classroom%20flip%20reversible%20art%20activity%20white%20background%20product%20photography%20child-safe%20educational%20minimal&width=600&height=600&seq=prod-kara-002&orientation=squarish',
    description: 'Bir yüzü kara tahta, diğeri beyaz yazı tahtası çift yüzlü model',
  },
  {
    id: 803,
    categorySlug: 'karalama-tahtalari',
    name: 'Tekerlekli Sınıf Tahtası',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=rolling%20mobile%20chalkboard%20stand%20children%20classroom%20kindergarten%20large%20blackboard%20on%20wheels%20natural%20birch%20wood%20frame%20movable%20educational%20furniture%20white%20background%20product%20photography%20practical%20flexible%20classroom&width=600&height=600&seq=prod-kara-003&orientation=squarish',
    description: 'Tekerlekli taşınabilir, büyük yüzeyli sınıf kara tahtası',
  },
  {
    id: 804,
    categorySlug: 'karalama-tahtalari',
    name: 'Masa Üstü Mini Tahta Seti',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=small%20tabletop%20mini%20chalkboard%20set%20children%20natural%20birch%20wood%20frame%20with%20chalk%20eraser%20tray%20kindergarten%20activity%20white%20background%20product%20photography%20cute%20minimal%20personal%20slate%20board&width=600&height=600&seq=prod-kara-004&orientation=squarish',
    description: 'Kişisel kullanım için masa üstü mini tahta ve tebeşir seti',
  },
  {
    id: 805,
    categorySlug: 'karalama-tahtalari',
    name: 'Boyalı Şövale Kara Tahta',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=painted%20pastel%20coral%20children%20art%20easel%20chalkboard%20natural%20birch%20wood%20adjustable%20height%20kindergarten%20art%20studio%20furniture%20white%20background%20product%20photography%20creative%20design%20cute%20colorful&width=600&height=600&seq=prod-kara-005&orientation=squarish',
    description: 'Mercan boyalı, ayarlanabilir yükseklikli sanat şövale tahtası',
  },
  {
    id: 806,
    categorySlug: 'karalama-tahtalari',
    name: 'Büyük Format Çocuk Kara Tahtası',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=large%20format%20floor%20standing%20children%20chalkboard%20natural%20solid%20birch%20wood%20thick%20frame%20premium%20kindergarten%20classroom%20wall%20art%20mural%20writing%20white%20background%20product%20photography%20quality%20craftsmanship%20Scandinavian&width=600&height=600&seq=prod-kara-006&orientation=squarish',
    description: 'Zemin üstü büyük format, premium kalın çerçeveli kara tahta',
  },
  {
    id: 807,
    categorySlug: 'karalama-tahtalari',
    name: 'Çerçevesiz Kara Tahta Panel',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=frameless%20chalkboard%20wall%20panel%20children%20kindergarten%20smooth%20matte%20black%20surface%20wall-mounted%20borderless%20modern%20minimal%20Scandinavian%20classroom%20art%20white%20background%20product%20photography%20clean%20simple%20design&width=600&height=600&seq=prod-kara-007&orientation=squarish',
    description: 'Çerçevesiz, minimalist duvara yapışan kara tahta paneli',
  },
  {
    id: 808,
    categorySlug: 'karalama-tahtalari',
    name: 'Eğimli Masa Üstü Tahta',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=angled%20tilted%20tabletop%20chalkboard%20children%20ergonomic%20natural%20birch%20wood%20frame%20adjustable%20angle%20kindergarten%20art%20table%20activity%20white%20background%20product%20photography%20practical%20creative%20design%20minimal&width=600&height=600&seq=prod-kara-008&orientation=squarish',
    description: 'Eğimli yüzeyli, ergonomik kullanım için masa üstü tahta',
  },
  {
    id: 809,
    categorySlug: 'karalama-tahtalari',
    name: 'Akıllı Manyetik Yazı Tahtası',
    price: 0,
    badge: 'Akıllı Tasarım',
    image: 'https://readdy.ai/api/search-image?query=smart%20magnetic%20whiteboard%20children%20classroom%20kindergarten%20dry-erase%20surface%20magnetic%20holds%20papers%20birch%20wood%20frame%20educational%20furniture%20white%20background%20product%20photography%20practical%20organized%20modern%20design&width=600&height=600&seq=prod-kara-009&orientation=squarish',
    description: 'Mıknatıslı, kağıt tutabilen çok amaçlı akıllı yazı tahtası',
  },
  {
    id: 810,
    categorySlug: 'karalama-tahtalari',
    name: 'Tebeşirli Duvara Çıkartma Tahta',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=chalkboard%20wall%20sticker%20decal%20children%20playroom%20kindergarten%20matte%20black%20peel-stick%20repositionable%20large%20area%20writing%20drawing%20white%20background%20product%20photography%20easy%20apply%20practical%20creative%20kids%20room&width=600&height=600&seq=prod-kara-010&orientation=squarish',
    description: 'Kolayca uygulanabilen, geniş alanlı duvara kara tahta çıkartması',
  },
  {
    id: 901,
    categorySlug: 'petek-kapamalari',
    name: 'Geometrik Kesim Beyaz Petek Kapağı',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=white%20MDF%20radiator%20cover%20panel%20geometric%20CNC%20cut%20pattern%20kindergarten%20classroom%20child-safe%20rounded%20edges%20clean%20minimal%20product%20photography%20white%20background%20warm%20modern%20design%20ventilation%20slots&width=600&height=600&seq=prod-petek-001&orientation=squarish',
    description: 'Geometrik CNC kesim desenli, beyaz MDF petek kapama paneli',
  },
  {
    id: 902,
    categorySlug: 'petek-kapamalari',
    name: 'Bulut Figürlü Petek Kapağı',
    price: 0,
    badge: 'Popüler',
    image: 'https://readdy.ai/api/search-image?query=radiator%20cover%20with%20cloud%20cutout%20shapes%20MDF%20panel%20white%20mint%20painted%20kindergarten%20wall-mounted%20child-safe%20rounded%20edges%20ventilation%20cloudpattern%20product%20photography%20white%20background%20cute%20playful%20preschool%20design&width=600&height=600&seq=prod-petek-002&orientation=squarish',
    description: 'Bulut formu kesimli sevimli tasarımlı petek kapama paneli',
  },
  {
    id: 903,
    categorySlug: 'petek-kapamalari',
    name: 'Yıldız Kesimli Petek Kapama',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=radiator%20cover%20star%20cutout%20pattern%20MDF%20panel%20natural%20birch%20wood%20finish%20kindergarten%20wall%20mounted%20child-safe%20ventilation%20stars%20pattern%20product%20photography%20white%20background%20Scandinavian%20minimal%20design%20preschool&width=600&height=600&seq=prod-petek-003&orientation=squarish',
    description: 'Yıldız delik motifli, naturel ahşap görünümlü petek kapama paneli',
  },
  {
    id: 904,
    categorySlug: 'petek-kapamalari',
    name: 'Dalga Ritmik Petek Kapağı',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=radiator%20cover%20wave%20pattern%20cutout%20MDF%20panel%20coral%20painted%20kindergarten%20wall%20mounted%20child-safe%20rounded%20edges%20ventilation%20rhythmic%20wave%20design%20product%20photography%20white%20background%20modern%20Scandinavian&width=600&height=600&seq=prod-petek-004&orientation=squarish',
    description: 'Dalga ritimli oymalı, mercan boyalı modern petek kapama paneli',
  },
  {
    id: 905,
    categorySlug: 'petek-kapamalari',
    name: 'Çiçek Lazer Kesim Petek Kapağı',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=radiator%20cover%20flower%20laser%20cut%20pattern%20MDF%20white%20panel%20kindergarten%20decorative%20ventilation%20flower%20motif%20product%20photography%20white%20background%20elegant%20Scandinavian%20classroom%20wall%20decoration%20safe&width=600&height=600&seq=prod-petek-005&orientation=squarish',
    description: 'Lazer kesim çiçek motifli, dekoratif petek kapama paneli',
  },
  {
    id: 906,
    categorySlug: 'petek-kapamalari',
    name: 'Raf Ekli Petek Kapama Ünitesi',
    price: 0,
    badge: 'Akıllı Tasarım',
    image: 'https://readdy.ai/api/search-image?query=radiator%20cover%20with%20top%20shelf%20storage%20natural%20birch%20wood%20panel%20functional%20ventilation%20decorative%20top%20surface%20kindergarten%20classroom%20double%20function%20furniture%20white%20background%20product%20photography%20practical%20design%20child-safe&width=600&height=600&seq=prod-petek-006&orientation=squarish',
    description: 'Üstünde raf bölümü bulunan, çift fonksiyonlu petek kapama ünitesi',
  },
  {
    id: 907,
    categorySlug: 'petek-kapamalari',
    name: 'Pastel Mint Petek Kapağı',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=radiator%20cover%20mint%20green%20painted%20MDF%20panel%20rectangular%20ventilation%20slots%20kindergarten%20playroom%20wall%20mounted%20child-safe%20clean%20product%20photography%20white%20background%20pastel%20Scandinavian%20style%20preschool&width=600&height=600&seq=prod-petek-007&orientation=squarish',
    description: 'Pastel mint yeşili boyalı, sade çizgi desenli petek kapama paneli',
  },
  {
    id: 908,
    categorySlug: 'petek-kapamalari',
    name: 'Tam Duvar Petek Kaplama Seti',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=full%20wall%20width%20radiator%20cover%20panel%20set%20natural%20birch%20wood%20MDF%20large%20coverage%20kindergarten%20complete%20wall%20solution%20ventilation%20pattern%20product%20photography%20white%20background%20premium%20quality%20Scandinavian&width=600&height=600&seq=prod-petek-008&orientation=squarish',
    description: 'Duvar genişliğinde tam kaplama için tasarlanmış petek kapama seti',
  },
  {
    id: 909,
    categorySlug: 'petek-kapamalari',
    name: 'Hayvan Figürlü Petek Kapağı',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=radiator%20cover%20with%20animal%20silhouette%20cutout%20CNC%20pattern%20rabbit%20bird%20butterfly%20MDF%20white%20panel%20kindergarten%20decorative%20ventilation%20child-safe%20product%20photography%20white%20background%20charming%20playful%20design%20preschool&width=600&height=600&seq=prod-petek-009&orientation=squarish',
    description: 'Tavşan ve kuş silüetli oymalı, şirin hayvan figürlü petek kapağı',
  },
  {
    id: 910,
    categorySlug: 'petek-kapamalari',
    name: 'Doğal Ahşap Dokulu Petek Kapağı',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=natural%20wood%20grain%20texture%20radiator%20cover%20panel%20real%20birch%20wood%20veneer%20kindergarten%20classroom%20warm%20natural%20ventilation%20slots%20premium%20quality%20product%20photography%20white%20background%20Scandinavian%20minimal%20elegant%20design&width=600&height=600&seq=prod-petek-010&orientation=squarish',
    description: 'Gerçek ahşap kaplamalı, doğal doku görünümlü premium petek kapağı',
  },
  {
    id: 1001,
    categorySlug: 'tema-duvar-setleri',
    name: 'Orman Temali 3D Duvar Seti',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=3D%20layered%20forest%20theme%20wall%20decoration%20set%20kindergarten%20dimensional%20paper-cut%20trees%20mushrooms%20animals%20pastel%20green%20sage%20warm%20beige%20tones%20full%20wall%20coverage%20product%20photography%20white%20background%20premium%20quality%20preschool%20interior&width=600&height=600&seq=prod-tema-001&orientation=squarish',
    description: 'Ormandaki hayvanlar ve ağaçlarla 3 boyutlu orman temalı duvar seti',
  },
  {
    id: 1002,
    categorySlug: 'tema-duvar-setleri',
    name: 'Uzay Galaksi Duvar Dekor Seti',
    price: 0,
    badge: 'Popüler',
    image: 'https://readdy.ai/api/search-image?query=space%20galaxy%20theme%203D%20wall%20decoration%20set%20kindergarten%20dimensional%20rocket%20planets%20stars%20astronaut%20pastel%20navy%20mint%20coral%20tones%20full%20wall%20coverage%20product%20photography%20white%20background%20premium%20preschool%20modern%20classroom&width=600&height=600&seq=prod-tema-002&orientation=squarish',
    description: 'Roket, gezegen ve yıldızlarla uzay galaksi temalı duvar dekor seti',
  },
  {
    id: 1003,
    categorySlug: 'tema-duvar-setleri',
    name: 'Okyanus Altı Duvar Seti',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=underwater%20ocean%20theme%203D%20wall%20decoration%20set%20kindergarten%20dimensional%20fish%20coral%20seaweed%20whale%20pastel%20blue%20aqua%20teal%20tones%20full%20wall%20coverage%20product%20photography%20white%20background%20premium%20preschool%20playful&width=600&height=600&seq=prod-tema-003&orientation=squarish',
    description: 'Balıklar, mercanlar ve deniz canlılarıyla okyanusaltı duvar seti',
  },
  {
    id: 1004,
    categorySlug: 'tema-duvar-setleri',
    name: 'Çiftlik Dünyası Duvar Dekorasyonu',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=farm%20theme%203D%20wall%20decoration%20set%20kindergarten%20dimensional%20barn%20animals%20tractor%20wheat%20field%20pastel%20warm%20orange%20green%20tones%20full%20wall%20coverage%20product%20photography%20white%20background%20premium%20preschool%20cheerful%20country%20style&width=600&height=600&seq=prod-tema-004&orientation=squarish',
    description: 'Çiftlik hayvanları ve traktörlerle kırsal hayat duvar dekor seti',
  },
  {
    id: 1005,
    categorySlug: 'tema-duvar-setleri',
    name: 'Safari Serüveni Duvar Seti',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=safari%20adventure%20theme%203D%20wall%20decoration%20set%20kindergarten%20dimensional%20giraffe%20elephant%20lion%20acacia%20trees%20pastel%20warm%20sand%20beige%20orange%20tones%20full%20wall%20coverage%20product%20photography%20white%20background%20premium%20preschool&width=600&height=600&seq=prod-tema-005&orientation=squarish',
    description: 'Afrika hayvanları ve akasya ağaçlarıyla safari temalı duvar seti',
  },
  {
    id: 1006,
    categorySlug: 'tema-duvar-setleri',
    name: 'Peri Ormanı Duvar Dekor Seti',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=enchanted%20fairy%20forest%20theme%203D%20wall%20decoration%20set%20kindergarten%20dimensional%20mushroom%20houses%20fireflies%20fairy%20magic%20pastel%20pink%20lavender%20mint%20tones%20full%20wall%20coverage%20product%20photography%20white%20background%20premium%20preschool%20girls%20room&width=600&height=600&seq=prod-tema-006&orientation=squarish',
    description: 'Mantar evleri ve perilerle büyülü orman temalı premium duvar seti',
  },
  {
    id: 1007,
    categorySlug: 'tema-duvar-setleri',
    name: 'Dinozor Çağı Duvar Seti',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=dinosaur%20age%20theme%203D%20wall%20decoration%20set%20kindergarten%20dimensional%20t-rex%20stegosaurus%20brachiosaurus%20prehistoric%20jungle%20pastel%20green%20coral%20yellow%20tones%20full%20wall%20coverage%20product%20photography%20white%20background%20premium%20preschool%20boys%20room&width=600&height=600&seq=prod-tema-007&orientation=squarish',
    description: 'Çeşitli dinozor türleriyle prehistorik çağ temalı duvar dekor seti',
  },
  {
    id: 1008,
    categorySlug: 'tema-duvar-setleri',
    name: 'Masallar Şehri Duvar Dekorasyonu',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=fairytale%20storybook%20town%20theme%203D%20wall%20decoration%20set%20kindergarten%20dimensional%20castle%20cottage%20windmill%20bridge%20pastel%20warm%20tones%20full%20wall%20coverage%20product%20photography%20white%20background%20premium%20preschool%20whimsical%20charming&width=600&height=600&seq=prod-tema-008&orientation=squarish',
    description: 'Kale ve masalsı köy sahnesiyle storybook temalı duvar seti',
  },
  {
    id: 1009,
    categorySlug: 'tema-duvar-setleri',
    name: 'Şehir Hayatı Duvar Seti',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=city%20life%20theme%203D%20wall%20decoration%20set%20kindergarten%20dimensional%20buildings%20cars%20streets%20park%20modern%20pastel%20coral%20mint%20yellow%20tones%20full%20wall%20coverage%20product%20photography%20white%20background%20premium%20preschool%20modern%20urban&width=600&height=600&seq=prod-tema-009&orientation=squarish',
    description: 'Modern şehir binalar, arabalar ve parkla şehir yaşamı duvar seti',
  },
  {
    id: 1010,
    categorySlug: 'tema-duvar-setleri',
    name: 'Gökyüzü ve Bulutlar Duvar Seti',
    price: 0,
    badge: 'Akıllı Tasarım',
    image: 'https://readdy.ai/api/search-image?query=sky%20clouds%20theme%203D%20wall%20decoration%20set%20kindergarten%20dimensional%20fluffy%20clouds%20sun%20hot%20air%20balloon%20rainbow%20birds%20pastel%20blue%20white%20yellow%20tones%20full%20wall%20coverage%20product%20photography%20white%20background%20premium%20preschool%20dreamy&width=600&height=600&seq=prod-tema-010&orientation=squarish',
    description: 'Balon, gökkuşağı ve bulutlarla gökyüzü temalı hafif dekor seti',
  },
  {
    id: 1101,
    categorySlug: 'galosluk',
    name: 'Gökkuşağı Bulut Galoşluk',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=colorful%20MDF%20shoe%20cover%20dispenser%20organizer%20wall-mounted%20kindergarten%20rainbow%20arc%20top%20cloud%20cutout%20pastel%20colors%20orange%20sky%20blue%20white%20cheerful%20product%20photography%20white%20background%20child-safe%20preschool%20entrance&width=600&height=600&seq=prod-galos-001&orientation=squarish',
    description: 'Gökkuşağı yay ve bulut kesimli, renkli duvara monte galoşluk',
  },
  {
    id: 1102,
    categorySlug: 'galosluk',
    name: 'Hayvan Figürlü Tekli Galoşluk',
    price: 0,
    badge: 'Popüler',
    image: 'https://readdy.ai/api/search-image?query=single%20compartment%20shoe%20cover%20dispenser%20kindergarten%20wall%20mounted%20cute%20animal%20face%20decoration%20bear%20rabbit%20birch%20wood%20MDF%20pastel%20colors%20product%20photography%20white%20background%20child-safe%20simple%20functional%20preschool%20entrance&width=600&height=600&seq=prod-galos-002&orientation=squarish',
    description: 'Sevimli hayvan figürlü tek bölmeli pratik galoşluk ünitesi',
  },
  {
    id: 1103,
    categorySlug: 'galosluk',
    name: 'Çift Bölmeli Büyük Galoşluk',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=double%20compartment%20large%20shoe%20cover%20dispenser%20kindergarten%20wall%20mounted%20colorful%20MDF%20two%20section%20dirty%20clean%20shoe%20icons%20pastel%20colors%20product%20photography%20white%20background%20high%20capacity%20child-safe%20functional%20preschool&width=600&height=600&seq=prod-galos-003&orientation=squarish',
    description: 'Kirli/temiz bölmeli, yüksek kapasiteli çift bölmeli galoşluk',
  },
  {
    id: 1104,
    categorySlug: 'galosluk',
    name: 'Pastel Sarı Minimal Galoşluk',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=minimal%20pastel%20yellow%20MDF%20shoe%20cover%20dispenser%20kindergarten%20wall%20mounted%20simple%20clean%20design%20product%20photography%20white%20background%20child-safe%20Scandinavian%20style%20minimal%20preschool%20entrance&width=600&height=600&seq=prod-galos-004&orientation=squarish',
    description: 'Sade sarı boyalı, minimalist duvar tipi galoşluk dispenseri',
  },
  {
    id: 1105,
    categorySlug: 'galosluk',
    name: 'Robot Temalı Çocuk Galoşluk',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=robot%20face%20theme%20MDF%20shoe%20cover%20dispenser%20children%20kindergarten%20wall%20mounted%20cute%20cartoon%20robot%20eyes%20mouth%20pastel%20mint%20silver%20tones%20product%20photography%20white%20background%20cheerful%20playful%20preschool%20entrance%20design&width=600&height=600&seq=prod-galos-005&orientation=squarish',
    description: 'Robot yüzlü şirin tasarımlı, çocukların sevdiği galoşluk',
  },
  {
    id: 1106,
    categorySlug: 'galosluk',
    name: 'Üçlü Blok Galoşluk Seti',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=triple%20block%20shoe%20cover%20dispenser%20set%20kindergarten%20wall%20mounted%20three%20units%20coral%20mint%20yellow%20each%20section%20color%20coded%20MDF%20product%20photography%20white%20background%20high%20capacity%20premium%20quality%20functional%20preschool%20entrance&width=600&height=600&seq=prod-galos-006&orientation=squarish',
    description: 'Üç renkli blok birimden oluşan geniş kapasiteli galoşluk seti',
  },
  {
    id: 1107,
    categorySlug: 'galosluk',
    name: 'Kelebek Kesimli Galoşluk',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=butterfly%20cutout%20decorative%20MDF%20shoe%20cover%20dispenser%20kindergarten%20wall%20mounted%20pastel%20pink%20white%20whimsical%20design%20product%20photography%20white%20background%20charming%20feminine%20preschool%20entrance%20girls%20room&width=600&height=600&seq=prod-galos-007&orientation=squarish',
    description: 'Kelebek oymalı dekoratif, pembe pastel boyalı galoşluk',
  },
  {
    id: 1108,
    categorySlug: 'galosluk',
    name: 'Yıldız Rozet Galoşluk',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=star%20badge%20design%20MDF%20shoe%20cover%20dispenser%20kindergarten%20wall%20mounted%20coral%20orange%20pastel%20fun%20cheerful%20product%20photography%20white%20background%20child-safe%20functional%20preschool%20entrance%20simple%20fun%20design&width=600&height=600&seq=prod-galos-008&orientation=squarish',
    description: 'Yıldız rozet tasarımlı, neşeli mercan renkli galoşluk ünitesi',
  },
  {
    id: 1109,
    categorySlug: 'galosluk',
    name: 'Naturel Ahşap Kare Galoşluk',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=natural%20wood%20finish%20square%20MDF%20shoe%20cover%20dispenser%20kindergarten%20wall%20mounted%20clean%20Scandinavian%20minimal%20design%20product%20photography%20white%20background%20child-safe%20warm%20wood%20grain%20texture%20simple%20functional%20preschool&width=600&height=600&seq=prod-galos-009&orientation=squarish',
    description: 'Naturel ahşap görünümlü, sade Scandi tarz kare galoşluk',
  },
  {
    id: 1110,
    categorySlug: 'galosluk',
    name: 'Büyük Kapasiteli Sınıf Galoşluk Ünitesi',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=large%20capacity%20classroom%20shoe%20cover%20unit%20kindergarten%20wide%20wall%20mounted%20MDF%20multiple%20compartment%20high%20volume%20dispenser%20organized%20product%20photography%20white%20background%20practical%20premium%20quality%20preschool%20entrance%20institutional&width=600&height=600&seq=prod-galos-010&orientation=squarish',
    description: 'Büyük sınıflar için yüksek kapasiteli kurumsal galoşluk ünitesi',
  },
  {
    id: 1201,
    categorySlug: 'tavan-panelleri',
    name: 'Bulut Sürüsü Tavan Seti',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=cloud%20hanging%20ceiling%20decoration%20set%20children%20kindergarten%20natural%20birch%20wood%20white%20fluffy%20cloud%20shapes%203D%20dimensional%20product%20photography%20white%20background%20whimsical%20dream%20nursery%20preschool%20classroom%20decor&width=600&height=600&seq=prod-tavan-001&orientation=squarish',
    description: 'Ahşap ve keçe bulut figürlerinden oluşan tavan dekor seti',
  },
  {
    id: 1202,
    categorySlug: 'tavan-panelleri',
    name: 'Güneş Sistemi Asma Seti',
    price: 0,
    badge: 'Popüler',
    image: 'https://readdy.ai/api/search-image?query=solar%20system%20hanging%20ceiling%20decoration%20children%20kindergarten%20natural%20birch%20wood%20planets%20sun%20moon%20stars%20colorful%203D%20dimensional%20product%20photography%20white%20background%20educational%20space%20preschool%20classroom%20mobile%20decor&width=600&height=600&seq=prod-tavan-002&orientation=squarish',
    description: 'Renkli gezegenler ve güneşten oluşan eğitici tavan asma seti',
  },
  {
    id: 1203,
    categorySlug: 'tavan-panelleri',
    name: 'Orman Hayvanları Tavan Paneli',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=forest%20animals%20hanging%20ceiling%20decoration%20children%20kindergarten%20natural%20birch%20wood%20fox%20owl%20deer%20butterfly%20colorful%203D%20dimensional%20product%20photography%20white%20background%20charming%20preschool%20woodland%20classroom%20mobile%20decor&width=600&height=600&seq=prod-tavan-003&orientation=squarish',
    description: 'Orman hayvanları figürlü, sevimli tavan dekor asma paneli',
  },
  {
    id: 1204,
    categorySlug: 'tavan-panelleri',
    name: 'Gökkuşağı Asma Tavan Seti',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=rainbow%20hanging%20ceiling%20decoration%20children%20kindergarten%20fabric%20felt%20colorful%20arc%20clouds%20stars%20product%20photography%20white%20background%20dreamy%20colorful%20nursery%20preschool%20classroom%20ceiling%20mobile&width=600&height=600&seq=prod-tavan-004&orientation=squarish',
    description: 'Renkli gökkuşağı ve bulutlardan oluşan tavan asma dekor seti',
  },
  {
    id: 1205,
    categorySlug: 'tavan-panelleri',
    name: 'Kelebek Sürüsü Tavan Dekoru',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=butterfly%20flock%20hanging%20ceiling%20decoration%20children%20kindergarten%20colorful%20pastel%20fabric%20felt%203D%20butterflies%20various%20sizes%20product%20photography%20white%20background%20charming%20girls%20room%20preschool%20classroom%20ceiling%20decor&width=600&height=600&seq=prod-tavan-005&orientation=squarish',
    description: 'Çeşitli boyutlarda renkli kelebek figürlü tavan dekor seti',
  },
  {
    id: 1206,
    categorySlug: 'tavan-panelleri',
    name: 'Yıldız Gece Işıklı Tavan Paneli',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=star%20night%20light%20ceiling%20panel%20children%20kindergarten%20LED%20soft%20glow%20stars%20moon%20constellation%20pattern%20natural%20birch%20wood%20frame%20product%20photography%20dark%20background%20magical%20dreamy%20preschool%20bedroom%20classroom%20decor&width=600&height=600&seq=prod-tavan-006&orientation=squarish',
    description: 'LED ışıklı yıldız ve ay figürlü, büyülü ışıklı tavan paneli',
  },
  {
    id: 1207,
    categorySlug: 'tavan-panelleri',
    name: 'Akustik Tavan Dekor Paneli',
    price: 0,
    badge: 'Akıllı Tasarım',
    image: 'https://readdy.ai/api/search-image?query=acoustic%20ceiling%20panel%20children%20kindergarten%20sound%20absorbing%20decorative%20cloud%20shape%20soft%20felt%20fabric%20colorful%20pastel%20tones%20product%20photography%20white%20background%20practical%20functional%20noise%20reduction%20preschool%20classroom&width=600&height=600&seq=prod-tavan-007&orientation=squarish',
    description: 'Ses yutucu özellikli, dekoratif bulut formlu akustik tavan paneli',
  },
  {
    id: 1208,
    categorySlug: 'tavan-panelleri',
    name: 'Uçak ve Helikopter Tavan Seti',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=airplane%20helicopter%20hanging%20ceiling%20mobile%20children%20kindergarten%20natural%20birch%20wood%20painted%20vehicles%20pastel%20coral%20yellow%20blue%203D%20dimensional%20product%20photography%20white%20background%20boys%20room%20preschool%20classroom%20ceiling%20decor%20transport&width=600&height=600&seq=prod-tavan-008&orientation=squarish',
    description: 'Uçak ve helikopter figürlü, renkli ahşap tavan asma seti',
  },
  {
    id: 1209,
    categorySlug: 'tavan-panelleri',
    name: 'Çiçekli Asma Bahçe Tavan Seti',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=hanging%20flower%20garden%20ceiling%20mobile%20children%20kindergarten%20fabric%20felt%20flowers%20leaves%20pastel%20pink%20yellow%20green%20product%20photography%20white%20background%20spring%20cheerful%20girls%20preschool%20classroom%20ceiling%20decor%20botanical&width=600&height=600&seq=prod-tavan-009&orientation=squarish',
    description: 'Çiçekler ve yapraklardan oluşan asma bahçe tavan dekor seti',
  },
  {
    id: 1210,
    categorySlug: 'tavan-panelleri',
    name: 'Okyanus Canlıları Tavan Mobili',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=ocean%20sea%20creatures%20ceiling%20mobile%20hanging%20decoration%20children%20kindergarten%20fabric%20felt%20fish%20whale%20jellyfish%20seahorse%20pastel%20blue%20aqua%20tones%20product%20photography%20white%20background%20dreamy%20underwater%20preschool%20classroom&width=600&height=600&seq=prod-tavan-010&orientation=squarish',
    description: 'Balık, denizatı ve medüz figürlü okyanus temalı tavan mobili',
  },
  {
    id: 1301,
    categorySlug: 'rol-oyun-alani',
    name: 'Mini Market Oyun Köşesi',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=children%20mini%20market%20grocery%20store%20play%20corner%20natural%20birch%20wood%20shelves%20cash%20register%20counter%20pretend%20play%20colorful%20toy%20food%20products%20kindergarten%20role%20play%20furniture%20white%20background%20product%20photography%20child-safe%20Montessori%20quality&width=600&height=600&seq=prod-rol-001&orientation=squarish',
    description: 'Kasiyerlik ve alışveriş için tam donanımlı mini market oyun köşesi',
  },
  {
    id: 1302,
    categorySlug: 'rol-oyun-alani',
    name: 'Doktor Muayenehanesi Seti',
    price: 0,
    badge: 'Popüler',
    image: 'https://readdy.ai/api/search-image?query=children%20doctor%20office%20play%20set%20natural%20birch%20wood%20examination%20table%20cabinet%20medical%20play%20accessories%20white%20pastel%20kindergarten%20role%20play%20furniture%20white%20background%20product%20photography%20Montessori%20learning&width=600&height=600&seq=prod-rol-002&orientation=squarish',
    description: 'Muayene masası ve dolabıyla doktor orisi temalı rol oyun seti',
  },
  {
    id: 1303,
    categorySlug: 'rol-oyun-alani',
    name: 'Kahvehane Oyun Köşesi',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=children%20cafe%20coffee%20shop%20play%20corner%20natural%20birch%20wood%20counter%20espresso%20machine%20pretend%20play%20menu%20colorful%20kindergarten%20role%20play%20furniture%20white%20background%20product%20photography%20creative%20Montessori%20design&width=600&height=600&seq=prod-rol-003&orientation=squarish',
    description: 'Kahve makineli, menülü mini kahvehane rol oyun köşesi',
  },
  {
    id: 1304,
    categorySlug: 'rol-oyun-alani',
    name: 'İtfaiye İstasyonu Oyun Seti',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=children%20fire%20station%20play%20set%20natural%20birch%20wood%20fire%20truck%20garage%20pole%20slide%20accessories%20red%20pastel%20kindergarten%20role%20play%20furniture%20white%20background%20product%20photography%20exciting%20design&width=600&height=600&seq=prod-rol-004&orientation=squarish',
    description: 'İtfaiye aracı garajı ve kayma direğiyle itfaiye oyun seti',
  },
  {
    id: 1305,
    categorySlug: 'rol-oyun-alani',
    name: 'Banka / Post Ofis Oyun Seti',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=children%20bank%20post%20office%20play%20set%20natural%20birch%20wood%20counter%20windows%20pretend%20money%20stamps%20kindergarten%20role%20play%20furniture%20white%20background%20product%20photography%20Montessori%20learning&width=600&height=600&seq=prod-rol-005&orientation=squarish',
    description: 'Para ve posta işlemleri için banka/post ofisi oyun köşesi',
  },
  {
    id: 1306,
    categorySlug: 'rol-oyun-alani',
    name: 'Kuaför Salonu Oyun Köşesi',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=children%20beauty%20salon%20hairdresser%20play%20corner%20mirror%20chair%20natural%20birch%20wood%20pastel%20pink%20accessories%20pretend%20play%20kindergarten%20role%20play%20furniture%20white%20background%20product%20photography%20Montessori%20design&width=600&height=600&seq=prod-rol-006&orientation=squarish',
    description: 'Ayna, sandalye ve aksesuar setiyle kuaför salonu oyun köşesi',
  },
  {
    id: 1307,
    categorySlug: 'rol-oyun-alani',
    name: 'Müzik Stüdyosu Oyun Seti',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=children%20music%20studio%20play%20set%20natural%20birch%20wood%20mini%20stage%20microphone%20stand%20instruments%20keyboard%20drum%20set%20kindergarten%20role%20play%20furniture%20white%20background%20product%20photography%20creative%20design&width=600&height=600&seq=prod-rol-007&orientation=squarish',
    description: 'Sahne, mikrofon ve enstrümanlarla müzik stüdyosu oyun seti',
  },
  {
    id: 1308,
    categorySlug: 'rol-oyun-alani',
    name: 'Çiftlik Rol Oyun Köşesi',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=children%20farm%20role%20play%20corner%20natural%20birch%20wood%20barn%20animal%20enclosure%20tractor%20toy%20milk%20station%20pastel%20warm%20tones%20kindergarten%20furniture%20white%20background%20product%20photography%20Montessori%20country%20theme&width=600&height=600&seq=prod-rol-008&orientation=squarish',
    description: 'Ahır, hayvan çitleri ve traktörle çiftlik temalı rol oyun köşesi',
  },
  {
    id: 1309,
    categorySlug: 'rol-oyun-alani',
    name: 'Uzay Gemisi Rol Oyun Seti',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=children%20spaceship%20role%20play%20set%20natural%20birch%20wood%20control%20panel%20windows%20stars%20astronaut%20costume%20area%20pastel%20navy%20mint%20kindergarten%20furniture%20white%20background%20product%20photography%20creative%20modern%20design&width=600&height=600&seq=prod-rol-009&orientation=squarish',
    description: 'Kontrol paneli ve kostüm köşesiyle uzay gemisi rol oyun seti',
  },
  {
    id: 1310,
    categorySlug: 'rol-oyun-alani',
    name: 'Kütüphane Okuma Köşesi',
    price: 0,
    badge: 'Akıllı Tasarım',
    image: 'https://readdy.ai/api/search-image?query=children%20library%20reading%20role%20play%20corner%20natural%20birch%20wood%20book%20display%20shelf%20cozy%20reading%20nook%20cushion%20librarian%20desk%20kindergarten%20furniture%20white%20background%20product%20photography%20calm%20design&width=600&height=600&seq=prod-rol-010&orientation=squarish',
    description: 'Kitap standı ve kütüphaneci masasıyla mini kütüphane oyun köşesi',
  },
  {
    id: 1401,
    categorySlug: 'mini-atolye',
    name: 'Ahşap İşleme Atölye Tezgahı',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=children%20woodworking%20workshop%20bench%20natural%20birch%20wood%20toy%20tools%20hammer%20saw%20child-safe%20tools%20holder%20kindergarten%20Montessori%20activity%20workshop%20furniture%20white%20background%20product%20photography%20quality%20craftsmanship%20educational&width=600&height=600&seq=prod-atolye-001&orientation=squarish',
    description: 'Çocuk güvenli ahşap el aletleriyle mini ahşap işleme tezgahı',
  },
  {
    id: 1402,
    categorySlug: 'mini-atolye',
    name: 'Sanat Atölyesi Masası',
    price: 0,
    badge: 'Popüler',
    image: 'https://readdy.ai/api/search-image?query=children%20art%20workshop%20table%20natural%20birch%20wood%20paint%20holder%20brushes%20tray%20art%20supplies%20organized%20kindergarten%20creative%20studio%20Montessori%20furniture%20white%20background%20product%20photography%20clean%20practical%20design&width=600&height=600&seq=prod-atolye-002&orientation=squarish',
    description: 'Boya, fırça ve malzeme tutacaklarıyla donanımlı sanat atölye masası',
  },
  {
    id: 1403,
    categorySlug: 'mini-atolye',
    name: 'Bilim ve Deney Seti Tezgahı',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=children%20science%20experiment%20workshop%20bench%20natural%20birch%20wood%20test%20tube%20holder%20magnifier%20microscope%20activity%20kindergarten%20STEM%20Montessori%20furniture%20white%20background%20product%20photography%20educational%20exploratory%20design&width=600&height=600&seq=prod-atolye-003&orientation=squarish',
    description: 'Tüp ve büyüteç tutacaklı, STEM odaklı bilim atölye tezgahı',
  },
  {
    id: 1404,
    categorySlug: 'mini-atolye',
    name: 'Pano ve Proje Tezgahı',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=children%20project%20display%20workshop%20bench%20natural%20birch%20wood%20corkboard%20whiteboard%20back%20panel%20project%20tools%20organized%20kindergarten%20creative%20Montessori%20furniture%20white%20background%20product%20photography%20clean%20practical&width=600&height=600&seq=prod-atolye-004&orientation=squarish',
    description: 'Mantar panolu arka duvarıyla proje teşhir ve çalışma tezgahı',
  },
  {
    id: 1405,
    categorySlug: 'mini-atolye',
    name: 'Tekstil ve Dikiş Atölye Köşesi',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=children%20sewing%20textile%20workshop%20corner%20natural%20birch%20wood%20fabric%20holder%20thread%20organizer%20child-safe%20sewing%20accessories%20kindergarten%20creative%20Montessori%20furniture%20white%20background%20product%20photography%20educational%20practical&width=600&height=600&seq=prod-atolye-005&orientation=squarish',
    description: 'Kumaş ve iplik organizasyonlu tekstil dikiş atölye köşesi',
  },
  {
    id: 1406,
    categorySlug: 'mini-atolye',
    name: 'Elektronik Devre Atölyesi',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=children%20electronics%20circuit%20workshop%20set%20natural%20birch%20wood%20component%20holder%20wiring%20activity%20board%20STEM%20kindergarten%20creative%20Montessori%20furniture%20white%20background%20product%20photography%20modern%20design&width=600&height=600&seq=prod-atolye-006&orientation=squarish',
    description: 'Devre ve kablo organizasyonlu mini elektronik STEM atölye seti',
  },
  {
    id: 1407,
    categorySlug: 'mini-atolye',
    name: 'Çömlek ve Seramik Atölye Köşesi',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=children%20pottery%20clay%20workshop%20table%20natural%20birch%20wood%20clay%20storage%20tools%20organized%20kindergarten%20creative%20Montessori%20messy%20play%20furniture%20white%20background%20product%20photography&width=600&height=600&seq=prod-atolye-007&orientation=squarish',
    description: 'Kil ve seramik çalışmaları için organizasyonlu atölye tezgahı',
  },
  {
    id: 1408,
    categorySlug: 'mini-atolye',
    name: 'Müzik Yapım Atölyesi',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=children%20music%20making%20workshop%20natural%20birch%20wood%20instrument%20holders%20rhythm%20tools%20shaker%20drum%20mallets%20organized%20kindergarten%20creative%20Montessori%20educational%20furniture%20white%20background%20product%20photography%20fun%20interactive&width=600&height=600&seq=prod-atolye-008&orientation=squarish',
    description: 'Ritim aletleri ve organizatörlü mini müzik yapım atölye',
  },
  {
    id: 1409,
    categorySlug: 'mini-atolye',
    name: 'Fotoğraf ve Film Atölye Köşesi',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=children%20photography%20film%20studio%20workshop%20corner%20natural%20birch%20wood%20camera%20stand%20backdrop%20holder%20lights%20kindergarten%20creative%20Montessori%20media%20arts%20furniture%20white%20background%20product%20photography%20modern%20design&width=600&height=600&seq=prod-atolye-009&orientation=squarish',
    description: 'Tripod ve arka plan tutucuyla mini fotoğraf stüdyo atölyesi',
  },
  {
    id: 1410,
    categorySlug: 'mini-atolye',
    name: 'Tasarım ve Mimarlık Atölye Masası',
    price: 0,
    badge: 'Akıllı Tasarım',
    image: 'https://readdy.ai/api/search-image?query=children%20design%20architecture%20workshop%20table%20natural%20birch%20wood%20drawing%20ruler%20tools%20organized%20slanted%20top%20work%20surface%20kindergarten%20STEM%20creative%20Montessori%20furniture%20white%20background%20product%20photography%20drafting%20table&width=600&height=600&seq=prod-atolye-010&orientation=squarish',
    description: 'Eğimli çizim yüzeyli, mimarlık ve tasarım odaklı atölye masası',
  },
  {
    id: 1501,
    categorySlug: 'mini-mutfak',
    name: 'Klasik Beyaz Mini Mutfak Seti',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=classic%20white%20children%20mini%20kitchen%20set%20natural%20birch%20wood%20cabinets%20stove%20oven%20sink%20fridge%20pretend%20play%20classic%20design%20kindergarten%20furniture%20white%20background%20product%20photography%20Montessori%20child-safe%20role%20play%20quality&width=600&height=600&seq=prod-mutfak-001&orientation=squarish',
    description: 'Ocak, fırın, buzdolabı ve lavaboyla klasik beyaz mini mutfak seti',
  },
  {
    id: 1502,
    categorySlug: 'mini-mutfak',
    name: 'Pastel Mint Şef Mutfağı',
    price: 0,
    badge: 'Popüler',
    image: 'https://readdy.ai/api/search-image?query=pastel%20mint%20green%20children%20chef%20kitchen%20set%20natural%20birch%20wood%20cooking%20station%20pot%20hooks%20utensil%20holders%20chalkboard%20menu%20kindergarten%20furniture%20white%20background%20product%20photography%20Montessori%20quality%20role%20play&width=600&height=600&seq=prod-mutfak-002&orientation=squarish',
    description: 'Tencere kancaları ve kara tahta menüyle şef mutfağı seti',
  },
  {
    id: 1503,
    categorySlug: 'mini-mutfak',
    name: 'Geniş L Köşe Mutfak Ünitesi',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=L-shaped%20corner%20children%20kitchen%20play%20set%20large%20natural%20birch%20wood%20pastel%20coral%20white%20comprehensive%20appliances%20island%20counter%20kindergarten%20premium%20furniture%20white%20background%20product%20photography%20Montessori%20complete%20role%20play&width=600&height=600&seq=prod-mutfak-003&orientation=squarish',
    description: 'Ada tezgahlı, geniş L formlu kapsamlı köşe mini mutfak ünitesi',
  },
  {
    id: 1504,
    categorySlug: 'mini-mutfak',
    name: 'Modern Endüstriyel Çocuk Mutfağı',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=modern%20industrial%20style%20children%20kitchen%20play%20set%20natural%20birch%20wood%20metal%20pipes%20bar%20shelves%20open%20concept%20pretend%20play%20kindergarten%20furniture%20white%20background%20product%20photography%20contemporary%20Montessori%20role%20play&width=600&height=600&seq=prod-mutfak-004&orientation=squarish',
    description: 'Metal boru detaylı, açık raflı modern endüstriyel stil mutfak',
  },
  {
    id: 1505,
    categorySlug: 'mini-mutfak',
    name: 'Fırın ve Pastane Seti',
    price: 0,
    badge: 'Sevilen Model',
    image: 'https://readdy.ai/api/search-image?query=children%20bakery%20pastry%20shop%20kitchen%20play%20set%20natural%20birch%20wood%20oven%20display%20case%20cake%20stand%20tray%20holder%20kindergarten%20role%20play%20furniture%20white%20background%20product%20photography%20sweet%20Montessori%20baking&width=600&height=600&seq=prod-mutfak-005&orientation=squarish',
    description: 'Pasta standlı ve fırın vitrinli mini pastane ve fırın oyun seti',
  },
  {
    id: 1506,
    categorySlug: 'mini-mutfak',
    name: 'Kahvaltı Köşesi Mini Mutfak',
    price: 0,
    badge: 'Yeni Sezon',
    image: 'https://readdy.ai/api/search-image?query=breakfast%20nook%20children%20mini%20kitchen%20set%20natural%20birch%20wood%20compact%20toaster%20juice%20press%20table%20simple%20pastel%20warm%20tones%20kindergarten%20furniture%20white%20background%20product%20photography%20cozy%20Montessori%20role%20play&width=600&height=600&seq=prod-mutfak-006&orientation=squarish',
    description: 'Tost makineli, kompakt kahvaltı temalı şirin mini mutfak seti',
  },
  {
    id: 1507,
    categorySlug: 'mini-mutfak',
    name: 'Rustik Ahşap Çiftlik Mutfağı',
    price: 0,
    badge: 'Özel Tasarım',
    image: 'https://readdy.ai/api/search-image?query=rustic%20farmhouse%20children%20play%20kitchen%20natural%20solid%20birch%20wood%20open%20shelves%20herb%20pots%20dish%20rack%20warm%20country%20style%20kindergarten%20furniture%20white%20background%20product%20photography%20charming%20Montessori%20role%20play&width=600&height=600&seq=prod-mutfak-007&orientation=squarish',
    description: 'Açık raflı, ot saksılı rustik çiftlik temalı premium ahşap mutfak',
  },
  {
    id: 1508,
    categorySlug: 'mini-mutfak',
    name: 'Açık Mutfak Ada Tezgahı',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=open%20kitchen%20island%20children%20play%20set%20natural%20birch%20wood%20bar%20stools%20counter%20work%20surface%20pretend%20cooking%20kindergarten%20furniture%20white%20background%20product%20photography%20modern%20Montessori%20role%20play&width=600&height=600&seq=prod-mutfak-008&orientation=squarish',
    description: 'Bar tabureleri ve çalışma yüzeyli açık mutfak ada tezgahı',
  },
  {
    id: 1509,
    categorySlug: 'mini-mutfak',
    name: 'Dondurma Büfesi Seti',
    price: 0,
    badge: 'Trend',
    image: 'https://readdy.ai/api/search-image?query=ice%20cream%20stand%20shop%20children%20play%20set%20natural%20birch%20wood%20colorful%20scoop%20display%20case%20waffle%20cone%20holder%20pastel%20kindergarten%20role%20play%20furniture%20white%20background%20product%20photography%20sweet%20fun%20Montessori&width=600&height=600&seq=prod-mutfak-009&orientation=squarish',
    description: 'Top ve külah tutacaklı mini dondurma büfesi oyun seti',
  },
  {
    id: 1510,
    categorySlug: 'mini-mutfak',
    name: 'Akıllı Teknolojik Mini Mutfak',
    price: 0,
    badge: 'Premium',
    image: 'https://readdy.ai/api/search-image?query=smart%20technology%20children%20play%20kitchen%20set%20natural%20birch%20wood%20LED%20panel%20touch%20buttons%20lights%20sounds%20interactive%20appliances%20kindergarten%20premium%20furniture%20white%20background%20product%20photography%20modern%20Montessori%20innovative%20role%20play&width=600&height=600&seq=prod-mutfak-010&orientation=squarish',
    description: 'LED ışıklı ve sesli interaktif dokunmatik panelli akıllı mini mutfak',
  },
];
